export default "__VITE_ASSET__Xh5gvOc1__"